export const WHATSAPP_LINK =
  'https://api.whatsapp.com/send/?phone=447454261074&text&type=phone_number&app_absent=0';
